import { Component, OnInit} from '@angular/core';
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";
import * as moment from 'moment';
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { DownloadFileService } from "@shared/services/download-file.service";
import { MatSelectChange } from '@angular/material/select';
import {jsPDF} from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-ceo-library',
  templateUrl: './ceo-library.component.html',
  styleUrls: ['./ceo-library.component.scss']
})
export class CeoLibraryComponent implements OnInit {

  libraryMap: { [key: number]: object } = {};

  libraryList: any[];

  selectedLibraryId: number;

  pageUrl: string;

  isMobileView = false;

  public inProgress:boolean = false;
  
  constructor(
    private route: ActivatedRoute, 
    private apiService: ApiService, 
    public sanitizer: DomSanitizer,
    public downloadFileService: DownloadFileService) { }

  ngOnInit() {
    this.readLibraryData();
    this.pageUrl = location.href;
    this.route.queryParams.subscribe((qp) => {
      if (qp["library-id"]) {
        this.selectedLibraryId = qp["library-id"];
      }
    });
  }

  public readLibraryData(){
    const obj = {
      type: "CEO-Library",
    };
    this.apiService.postData(Urls.readArticles, obj).subscribe(
      (response) => {
        response.data.articles.forEach(library => {
          if(library.video){
            const link = "https://www.youtube.com/embed/";
            if(library.video.startsWith('https://www.youtube.com/watch?')){
            const embed = library.video.split("watch?v=")[1];
            library.video = link + embed;
          }else if(library.video.startsWith("https://youtu.be/")){
            const embed = library.video.split("https://youtu.be/")[1];
            library.video = link + embed;
          }
          }
          const diff = moment(library.modifiedDate, "DD-MM-YYYY, h:mm:ss").fromNow();
          library.translatedModifiedDate =  `${diff} . Updated`;
          this.libraryMap[library.id] = library;
        });
        this.libraryList = response.data.articles || [];
       
        // --- default setting
        if (this.libraryList[0] && !this.selectedLibraryId) {
          this.selectedLibraryId = this.libraryList[0].id;
        }
      },
      (error) => {}
    );
  }

  public getSafeUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public downloadFile(path, name){
    this.downloadFileService.export(path).subscribe(
      data => saveAs(data, name + `.pdf`)
    );
  };

  public downloadAsPDF(libraryData: any) {
    if(libraryData){
      const name = libraryData.split("/").pop();
      this.inProgress = true;
      this.downloadFileService.export(libraryData).subscribe(
        data=>{
          this.inProgress = false;
          const  url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
  
      }, error=>{
        this.inProgress = true;
      });
      }
  }

  public onSelectionChange(change: MatSelectChange) {
    this.selectedLibraryId = change.value;
  }

}
